import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { map, Observable, shareReplay } from 'rxjs';
import { BasketService } from 'src/app/checkout-page/services/basket.service';
import { MediaModule } from 'src/layout/media/media.module';
import { ContentCacheUtils } from 'src/utils/storage.util';

@Component({
    selector: 'app-header-basket-button',
    standalone: true,
    imports: [CommonModule, MediaModule, TranslateModule, RouterModule],
    templateUrl: './header-basket-button.component.html',
    styleUrl: './header-basket-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderBasketButtonComponent {
    basketQuantity$: Observable<number>;
    basketUrl: string;
    constructor(
        private basketService: BasketService,

    ) {
        this.basketUrl = Object
        ?.entries(ContentCacheUtils.routing())
        ?.find(([path,key]) => key === 'basketPage')
        ?.find(() => true) ?? '/basket';
        this.basketQuantity$ = this.basketService.basket$.pipe(
            map(basket => basket?.quantity > 0 ? basket.quantity : null),
            shareReplay(1),
        );
    }
}
